gsap.registerPlugin(ScrollTrigger);

const tabs = gsap.utils.toArray(".main-tab-section .hb_tabs-section");

if (tabs.length > 0) {
  const pinDuration = tabs.length * window.innerHeight;
  // const pinDuration = window.innerHeight;
// console.log( pinDuration,'pinDuration');
  ScrollTrigger.create({
    trigger: ".hb_richext-section",
    start: "bottom bottom",
    end: () => `+=${pinDuration}`,
    pin: true,
    pinSpacing: false
  });

  ScrollTrigger.create({
    trigger: ".hb_richext-section",
    start: "bottom bottom",
    end: () => `+=${pinDuration}`,
    pin: ".hb_banner",
    pinSpacing: false
  });

  const firstTab = tabs[0]; 

  ScrollTrigger.create({
    trigger: firstTab,
    start: "bottom bottom",
    end: () => `+=${window.innerHeight}`,
    pin: true,
    pinSpacing: false,
    zIndex: 2,
    onEnter: () => lockScrollTemporarily(),
    onEnterBack: () => lockScrollTemporarily()
  });

  const overlay = firstTab.querySelector(".stacking-overlay");
  if (overlay) {
    gsap.fromTo(
      overlay,
      { opacity: 0, visibility: "visible" },
      {
        opacity: 0.5,
        ease: "none",
        scrollTrigger: {
          trigger: firstTab,
          start: "bottom bottom",
          end: () => `+=${window.innerHeight}`,
          scrub: true,
          onEnter: () => (overlay.style.visibility = "visible"),
          onLeaveBack: () => {
            overlay.style.opacity = 0;
            overlay.style.visibility = "hidden";
          }
        }
      }
    );
  }

  function lockScrollTemporarily() {
    document.documentElement.classList.add("scroll-lock");
    document.body.classList.add("scroll-lock");

    setTimeout(() => {
      document.documentElement.classList.remove("scroll-lock");
      document.body.classList.remove("scroll-lock");
    }, 1000); 
  }

  const header = document.querySelector("#header-component");
  const instagramSection = document.querySelector(".index-instagram-section-main");

  window.addEventListener("scroll", () => {
    const tabTop = firstTab.getBoundingClientRect().top;
    const instaTop = instagramSection.getBoundingClientRect().top;

    if (tabTop <= 60) {
      header.style.display = "none";
    }

    if (instaTop <= 0 || tabTop > 60) {
      header.style.display = "block";
    }
  });
}

$(".hb_collection-list__title-item:first-child").click();

$(document).ready(function (){

  // sticky tab grid on scroll
  // var collectionTabs = $(".hb_collection-list__wrap");
  // var headerHeight =  $("header").outerHeight();
  // var originalOffsetTop = collectionTabs.offset().top - headerHeight;
  // let lastScrollTop = 0;
  
  // $(window).on("scroll", function () {
  //   var scrollTop = $(this).scrollTop();
  //   lastScrollTop = scrollTop;
    
  //   if (scrollTop >= originalOffsetTop) {
  //     collectionTabs.addClass("sticky");
  //   } else {
  //     collectionTabs.removeClass("sticky");
  //   }
  // });

  
  var collectionTabs = $(".hb_collection-list__wrap");
  var collectionSection = $(".hb_collection-list");
  var headerHeight = $("header").outerHeight();
  var originalOffsetTop = collectionTabs.offset().top - headerHeight;

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var sectionBottom = collectionSection.offset().top + collectionSection.outerHeight();

    // When scroll is between top and bottom of the section
    if (scrollTop >= originalOffsetTop && scrollTop < sectionBottom - collectionTabs.outerHeight()) {
      collectionTabs.addClass("sticky");
    } else {
      collectionTabs.removeClass("sticky");
    }
  });

  // scroll to the selected collection
  $(".hb_collection-list__title-item").on("click", function(e){
    e.preventDefault();
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    if (this) {
      this.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
    const targetId = $(this).find("a").attr("href");
    const $target = $(targetId);
    if ($target.length) {
      const headerHeight = $("header").outerHeight() || 0;
      const stickyBarHeight = $(".hb_collection-list__wrap").outerHeight() || 0;
      const totalOffset = headerHeight + stickyBarHeight + 30;
      $("html, body").animate(
        {
          scrollTop: $target.offset().top - totalOffset,
        },200
      );
    }
  })
})

$(".faq_section .accordion .details").on("click", function(){
  $(this).closest("accordion-custom").siblings().find(".details").removeAttr('open');
})

// document.querySelectorAll('.about-img-with-text video').forEach(video => {
//   video.removeAttribute('controls');
// });

$(".about-img-with-text video").each(function(){
  $(this).removeAttr("controls");
})

// FAQ accordian js
$(".Page_faq_category_box_single_faq_question_container").on("click", function () {
  var isActive = $(this).hasClass("active");
  $(this).closest(".Page_faq_category_box_single_faq").siblings().find(".Page_faq_category_box_single_faq_question_container").removeClass("active");
  $(this).closest(".Page_faq_category_box_single_faq").siblings().find(".Page_faq_category_box_single_faq_answer").slideUp();
  if (!isActive) {
    $(this).addClass("active");
    $(this).siblings(".Page_faq_category_box_single_faq_answer").slideDown();
  }
  else{
    $(this).removeClass("active");
    $(this).siblings(".Page_faq_category_box_single_faq_answer").slideUp();
  }
});


// faq js
let manualTabClick = false;
let allowScrollActivation = true;
let scrollDebounce;

$(document).ready(function () {
  const $faqTabsBar = $(".Page_faq_tabs_section_main");
  const $faqTabsGrid = $(".Page_faq_tabs_grid");
  const headerHeight = $("header").outerHeight() || 0;
  const $lastCategory = $(".Page_faq_categories_section").last();

  const originalOffsetTop = $faqTabsBar.offset().top - headerHeight;

  $(window).on("scroll", function () {
    const scrollTop = $(this).scrollTop();
    const lastCategoryBottom = $lastCategory.offset().top + $lastCategory.outerHeight();

    if (scrollTop >= originalOffsetTop && scrollTop < lastCategoryBottom - $faqTabsBar.outerHeight()) {
      $faqTabsBar.addClass("sticky");
    } else {
      $faqTabsBar.removeClass("sticky");
    }
  });

  // Scroll to section on tab click
  $(".Page_faq_tab").on("click", function (e) {
    e.preventDefault();

    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    const $target = $($(this).attr("href"));
    const $stickyHeader = $("sticky-header, .sticky-header, #sticky-header");

    if (!$target.length) return;

    const headerHeight = $stickyHeader.outerHeight() || 0;
    const StickyFaqTabsHeight = $(".Page_faq_tabs_section_main").outerHeight() || 0;
    const targetOffset = $target.offset().top;

    const scrollOffset = headerHeight + StickyFaqTabsHeight + 40;

    // Lock scroll-based activation temporarily
    manualTabClick = true;
    allowScrollActivation = false;

    $("html, body").stop().animate(
      { scrollTop: targetOffset - scrollOffset },
      300,
      function () {
        manualTabClick = false;
        setTimeout(() => {
          allowScrollActivation = true;
        }, 100);
      }
    );

    // Scroll the tab into view horizontally
    this.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  });

  // Activate tab based on scroll position (only on mobile)
  // if ($(window).width() < 990) {
    $(window).on("scroll", function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        if (manualTabClick || !allowScrollActivation) return;

        const $stickyHeader = $("sticky-header, .sticky-header, #sticky-header");
        const headerHeight = $stickyHeader.outerHeight() || 0;
        const faqBarHeight = $faqTabsBar.outerHeight() || 0;
        const scrollTop = $(window).scrollTop();

        let activeSet = false;

        $(".Page_faq_tab").each(function () {
          const targetId = $(this).attr("href");
          const $targetSection = $(targetId);

          if (!$targetSection.length) return;

          const sectionTop = $targetSection.offset().top - headerHeight - faqBarHeight - 100; // extra buffer
          const sectionBottom = sectionTop + $targetSection.outerHeight();

          if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
            if (!$(this).hasClass("active")) {
              $(".Page_faq_tab").removeClass("active");
              $(this).addClass("active");

              // Scroll active tab into horizontal view
              this.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
            }

            activeSet = true;
            return false; // exit each loop
          }
        });

        if (!activeSet) {
          $(".Page_faq_tab").removeClass("active");
        }
      }, 50);
    });
  // }

});

// Scroll to section on tab click
$(".hb_tabs__tab--title").on("click", function (e) {
  this.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
});


// $(document).ready(function () {
//   // Click handler for navigation links
//   $(document).on('click', '.hb_tabs-section__tab-content a, .hb_header .submenu_item a', function(e) {
//     const href = $(this).attr('href');

//     if (href && href.includes('#')) {
//       e.preventDefault();
//       const hash = href.substring(href.indexOf('#'));

//       // If we're already on the collections page
//       if (window.location.pathname === '/collections') {
//         // Update hash manually
//         window.location.hash = hash;
//         // Manually trigger hashchange (optional if needed immediately)
//         $(window).trigger('hashchange');
//       } else {
//         // Navigate to the collections page with the hash
//         window.location.href = `https://duali.in/collections/?pb=0${hash}`;
//       }
//     }
//   });

//   // Function to handle activating the tab based on hash
//   function handleHashChange() {
//     const hash = window.location.hash;
//     if (hash) {
//       const $targetItem = $(".hb_collection-list__title-item").filter(function () {
//         return $(this).find("a").attr("href") === hash;
//       });

//       if ($targetItem.length) {
//         $targetItem.get(0).click();
//       }
//     }
//   }

//   // On page load
//   handleHashChange();

//   // On hash change (e.g., clicking submenu while already on the page)
//   $(window).on('hashchange', handleHashChange);
// });

// $(document).ready(function () {
//   // Click handler for navigation links
//   $(document).on('click', '.hb_tabs-section__tab-content a, .hb_header .submenu_item a', function(e) {
//     const href = $(this).attr('href');

//     if (href && href.includes('#')) {
//       e.preventDefault();
//       const hash = href.substring(href.indexOf('#'));

//       // Store the hash in sessionStorage
//       sessionStorage.setItem('pendingHash', hash);

//       // Always redirect to collections page without hash
//       window.location.href = 'https://duali.in/collections/?pb=0';
//     }
//   });

//   // Function to handle activating the tab based on stored or current hash
//   function handleHashChangeWithDelay(retries = 10, delay = 300) {
//     const hash = sessionStorage.getItem('pendingHash') || window.location.hash;

//     if (!hash) return;

//     function tryClick(attempt = 0) {
//       const $targetItem = $(".hb_collection-list__title-item").filter(function () {
//         return $(this).find("a").attr("href") === hash;
//       });

//       if ($targetItem.length) {
//         // Apply hash to the URL (without reload)
//         history.replaceState(null, null, hash);

//         // Trigger click
//         $targetItem.get(0).click();

//         // Clear the session storage if used
//         sessionStorage.removeItem('pendingHash');
//       } else if (attempt < retries) {
//         setTimeout(() => tryClick(attempt + 1), delay);
//       } else {
//         console.warn(`Could not find tab for hash "${hash}" after ${retries} attempts.`);
//       }
//     }

//     tryClick();
//   }

//   // On page load
//   handleHashChangeWithDelay();

//   // On hash change (if needed for internal links)
//   $(window).on('hashchange', handleHashChangeWithDelay);
// });


$(document).ready(function () {
  // Click handler for navigation links
  $(document).on('click', '.hb_tabs-section__tab-content a, .hb_header .submenu_item a', function(e) {
    const href = $(this).attr('href');

    if (href && href.includes('#')) {
      e.preventDefault();

      const hash = href.substring(href.indexOf('#'));
      const currentUrl = window.location.href;

      // Extract only the path part after domain
      const pathname = window.location.pathname;

      // ✅ If current page is exactly /collections (with or without a hash)
    if (pathname === '/collections') {
      if (window.location.hash !== hash) {
        window.location.hash = hash;
        $(window).trigger('hashchange');
      }
    } 
    // 🔁 Else (other pages, including /collections/cups)
    else {
      // sessionStorage.setItem('pendingHash', hash);
      // window.location.href = 'https://duali.in/collections';
      sessionStorage.setItem('pendingHash', hash);

        // Dynamically build URL to /collections on current domain & locale
        const origin = window.location.origin; // https://duali.co
        const pathParts = pathname.split('/').filter(part => part.length > 0);

        // Detect locale if it exists (e.g., en-ae, en-us)
        let localePrefix = '';
        if (pathParts.length > 0 && pathParts[0].includes('-')) {
          localePrefix = '/' + pathParts[0];
        }

        // Redirect to collections page on the same domain & locale
        window.location.href = `${origin}${localePrefix}/collections`;
    }
    }
  });

  // Function to activate tab based on hash (with retry support)
  function handleHashChangeWithRetry(retries = 10, delay = 300) {
    const hash = sessionStorage.getItem('pendingHash') || window.location.hash;

    if (!hash) return;

    function tryClick(attempt = 0) {
      const $targetItem = $(".hb_collection-list__title-item").filter(function () {
        return $(this).find("a").attr("href") === hash;
      });

      if ($targetItem.length) {
        // Replace hash in URL (no scroll jump)
        if (window.location.hash !== hash) {
          history.replaceState(null, null, hash);
        }

        $targetItem.get(0).click(); // trigger the click
        sessionStorage.removeItem('pendingHash'); // clear stored hash
      } else if (attempt < retries) {
        setTimeout(() => tryClick(attempt + 1), delay); // retry
      } else {
        console.warn(`Tab for hash "${hash}" not found after ${retries} attempts.`);
      }
    }

    tryClick();
  }

  // Trigger on initial load
  handleHashChangeWithRetry();

  // Trigger when hash changes
  $(window).on('hashchange', handleHashChangeWithRetry);
});



if($(window).width() < 990){
  $(".submenu_link").on("click", function(){
    $(".hb_header__left-menu").removeClass("active");
  })
}



// document.addEventListener('contextmenu', function (e) {
//     e.preventDefault();
//     alert('Right-click is disabled on this site.');
//   });